import MaterialPaper from "../../../../__snowpack__/pkg/@mui/material/Paper.js";
import React from "react";
import ReactDraggable from "../../../../__snowpack__/pkg/react-draggable.js";
function Draggable({
  handleSelector,
  cancelSelector,
  ...props
}) {
  const paperProps = props;
  return /* @__PURE__ */ React.createElement(ReactDraggable, {
    handle: handleSelector,
    cancel: cancelSelector
  }, /* @__PURE__ */ React.createElement(MaterialPaper, paperProps));
}
export default /* @__PURE__ */ React.memo(Draggable);
